<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h2"><a id="page_vii"><span class="bold">Contents</span></a></h1><a id="page_vii">
</a><h2 class="toc-front"><a id="page_vii"></a><a href="#/xhtml/07_Illustrations">List of illustrations</a></h2>
<h2 class="toc-front"><a href="#/xhtml/08_Abbreviations">List of terms and abbreviations</a></h2>
<h2 class="toc-front"><a href="#/xhtml/09_Preface">Preface</a></h2>
<h2 class="toc-front"><a href="#/xhtml/10_Acknowledgments">Acknowledgments</a></h2>
<h2 class="toc-front"><a href="#/xhtml/11_Maps">Map of operational areas</a></h2>
<h2 class="toc-chap1"><a href="#/xhtml/12_Chapter_01"><span class="hang">1</span> Feeling the War: August 1976</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/13_Chapter_02"><span class="hang">2</span> Chiduku, Makoni and Manyika Trifecta: August 1976</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter_03" title="Link target outside of Sample"><span class="hang">3</span> Eastern Border: September–October 1976</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_Chapter_04" title="Link target outside of Sample"><span class="hang">4</span> Inyanga, Chiduku Tango: December 1976</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_Chapter_05" title="Link target outside of Sample"><span class="hang">5</span> Mantle 151A: February 1977</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_Chapter_06" title="Link target outside of Sample"><span class="hang">6</span> Mantle Base Again: Late February 1977</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/18_Chapter_07" title="Link target outside of Sample"><span class="hang">7</span> Wedza Twice: April 1977</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/19_Chapter_08" title="Link target outside of Sample"><span class="hang">8</span> Beitbridge: July 1977</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/20_Chapter_09" title="Link target outside of Sample"><span class="hang">9</span> Chibi Twice: September 1977</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/21_Chapter_10" title="Link target outside of Sample"><span class="hang">10</span> Chiduku Yet Again: January 1978</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/22_Chapter_11" title="Link target outside of Sample"><span class="hang">11</span> Mangwende: March 1978</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/23_Chapter_12" title="Link target outside of Sample"><span class="hang">12</span> Recovery: April–July 1978</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/24_Chapter_13" title="Link target outside of Sample"><span class="hang">13</span> Western Border: August-September 1978</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/25_Chapter_14" title="Link target outside of Sample"><span class="hang">14</span> Interlude: October 1978</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/26_Chapter_15" title="Link target outside of Sample"><span class="hang">15</span> Gutsa: November 1978</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/27_Chapter_16" title="Link target outside of Sample"><span class="hang">16</span> Shot Again: January–June 1979</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/28_Chapter_17" title="Link target outside of Sample"><span class="hang">17</span> Shangaan Army: July-December 1979</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/29_Chapter_18" title="Link target outside of Sample"><span class="hang">18</span> The Final Months: January–May 1980</span></h2>
<h2 class="toc-back1"><span href="#/xhtml/30_Postscript" title="Link target outside of Sample">Postscript</span></h2>
<h2 class="toc-back"><span href="#/xhtml/31_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3b681075